import colors from "vuetify/lib/util/colors";

const content = {
  chart_threshold_colors: {
    Nom: colors.green.lighten3,
    Min: colors.blue.lighten3,
    Max: colors.red.lighten3,
    Alert: colors.red.accent4,
    UpperAvg: colors.red.lighten3,
    LowerAvg: colors.green.lighten3,
  },
  chart_phase_options: [
    {
      id: 0,
      label: "L1",
      color: { vt: "vtblue", electrical: "brown" },
      backgroundColor: { vt: "light-blue", electrical: "brown lighten-1" },
    },
    {
      id: 1,
      label: "L2",
      color: { vt: "vtred", electrical: "darkGrey" },
      backgroundColor: { vt: "amber", electrical: "grey lighten-1" },
    },
    {
      id: 2,
      label: "L3",
      color: { vt: "indigo", electrical: "lightGrey" },
      backgroundColor: { vt: "deep-purple", electrical: "grey lighten-2" },
    },
    {
      id: 3,
      label: "N",
      color: { vt: "brown lighten-1", electrical: "brown" },
      backgroundColor: { vt: "brown darken-1", electrical: "brown lighten-1" },
    },
  ],
  chart_values: [
    {
      id: 0,
      name: "Mean",
      label: "Mean",
      icon: "mdi-minus",
      color: "primary",
      tooltip: "Shown as a solid line",
    },
    {
      id: 1,
      name: "Min",
      label: "Min",
      icon: "mdi-view-headline",
      color: "primary",
      tooltip: "Shown as a dashed line",
    },
    {
      id: 2,
      name: "Max",
      label: "Max",
      icon: "mdi-dots-horizontal",
      color: "primary",
      tooltip: "Shown as a dotted line",
    },
  ],
  chart_palettes: {
    vt: {
      id: "vt",
      label: "VT",
      platform: "VT",
      line_colors: ["vtblue", "vtred", "indigo", "brown"],
      radio_color: "vtblue",
      point_marker_color: "orange",
    },
    h2scan: {
      id: "vt",
      label: "Custom",
      platform: "H2Scan",
      line_colors: ["vtblue", "vtred", "indigo", "brown"],
      radio_color: "vtblue",
      point_marker_color: "orange",
    },
    electrical: {
      id: "electrical",
      label: "Electrical",
      line_colors: ["brown", "darkGrey", "lightGrey", "brown"],
      radio_color: "brown",
      point_marker_color: "orange",
    },
  },
  weather_charts_checkbox_config: {
    AmbientTemperature: {
      id: "AmbientTemperature",
      label: "Show Ambient Temperature",
      key: "Temperature",
      availableTooltip: "Display the ambient temperature chart",
      unavailableTooltip: "Location details unavailable hence cannot display ambient temperature chart",
    },
    WindSpeed: {
      id: "WindSpeed",
      label: "Show Wind Speed",
      key: "Wind_Speed",
      availableTooltip: "Display the wind speed chart",
      unavailableTooltip: "Location details unavailable hence cannot display wind speed chart",
    },
    Solar: {
      id: "Solar",
      label: "Show Solar Magnitude",
      key: "Solar",
      availableTooltip: "Display the solar irrandiance chart",
      unavailableTooltip: "Location details unavailable hence cannot display solar irrandiance chart",
    },
  },
  weather_icons: {
    // Weather Icons re-mapping from OpenWeatherMap to Vuetify Icons
    "01d": { icon: "mdi-weather-sunny", color: "yellow darken-2" },
    "01n": { icon: "mdi-weather-night", color: "blue darken-4" },
    "02d": { icon: "mdi-weather-partly-cloudy", color: "grey lighten-1" },
    "02n": { icon: "mdi-weather-night-partly-cloudy", color: "blue grey darken-1" },
    "03d": { icon: "mdi-weather-cloudy", color: "grey darken-1" },
    "03n": { icon: "mdi-weather-cloudy", color: "grey darken-2" },
    "04d": { icon: "mdi-weather-cloudy", color: "grey darken-3" },
    "04n": { icon: "mdi-weather-cloudy", color: "grey darken-4" },
    "09d": { icon: "mdi-weather-rainy", color: "blue darken-3" },
    "09n": { icon: "mdi-weather-rainy", color: "blue darken-4" },
    "10d": { icon: "mdi-weather-pouring", color: "blue darken-3" },
    "10n": { icon: "mdi-weather-pouring", color: "blue darken-4" },
    "11d": { icon: "mdi-weather-lightning", color: "deep-purple darken-4" },
    "11n": { icon: "mdi-weather-lightning", color: "deep-purple darken-4" },
    "13d": { icon: "mdi-weather-snowy", color: "blue lighten-3" },
    "13n": { icon: "mdi-weather-snowy", color: "blue lighten-4" },
    "50d": { icon: "mdi-weather-fog", color: "grey lighten-2" },
    "50n": { icon: "mdi-weather-fog", color: "grey lighten-3" },
  },
};

export { content };
